import "./zPattern.css";

import UniCloudImg from "./homepage_images/home-images/unicloud01.png";
import UniPOSXImg from "./homepage_images/home-images/unipos1.png";
import UniPOSImg from "./homepage_images/home-images/uniPOS.png";

import ApprovalIcon from "@mui/icons-material/Approval";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SyncIcon from "@mui/icons-material/Sync";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function ZPattern() {
  return (
    <section className="sectionZpattern fx-cl">
      {/* =========================================================
          Z PATTERN — 01
          POS
      ========================================================= */}

      <div className="ZpatternCont">
        <div className="ZpatternLeft fx-cl space2">
          <span className="ZpatternEyebrow fx-ac space">
            <PointOfSaleIcon fontSize="small" />
            UNIVERSE POS
          </span>

          <h3 className="fs9 fw500 lh2">
            The <span>Universe POS</span>
            <br />
            More Than a Point of Sale
          </h3>

          <p className="fs5 fw500 lh3 ZpatternDescription">
            Your point of sale should do more than record a transaction. It
            should make selling faster, clearer, and easier for everyone using
            it.
          </p>

          <div className="ZpatternTags fx-ac wrap space1">
            <span className="ZpatterTag">Advanced</span>
            <span className="ZpatterTag">Simplified</span>
            <span className="ZpatterTag">Multi-scan</span>
            <span className="ZpatterTag">Real-time</span>
          </div>

          <div className="ZpatternFeatureGrid g g2 space2">
            <div className="ZpatternFeature fx-ac space">
              <span className="ZpatternSubicon fx-ac fx-jc">
                <ReceiptLongIcon />
              </span>

              <div className="fx-cl">
                <h4>Smart Checkout</h4>
                <p>Move from scan to payment without unnecessary steps.</p>
              </div>
            </div>

            <div className="ZpatternFeature fx-ac space">
              <span className="ZpatternSubicon fx-ac fx-jc">
                <TrendingUpIcon />
              </span>

              <div className="fx-cl">
                <h4>Live Reporting</h4>
                <p>See what is happening while your business is selling.</p>
              </div>
            </div>
          </div>

          <div className="ZpatternAction fx-ac space1">
            <button className="ZpatternButton fx-ac fx-jc space">
              Explore Universe POS
              <ArrowForwardIcon />
            </button>

            <span className="ZpatternActionHint">
              Built for everyday selling
            </span>
          </div>
        </div>

        <div className="ZpatterAimg ZpatterAimg--pos">
          <div className="ZpatternVisualGlow" />
          <img
            className="ZpatterAimg__main"
            src={UniPOSImg}
            alt="Universe POS dashboard"
          />

          {/* Checkout status */}
          <div className="ZvisualCard ZvisualCard--checkout shadowA">
            <div className="fx-ac fx-jb">
              <span className="ZvisualCardIcon fx-ac fx-jc">
                <PointOfSaleIcon />
              </span>

              <span className="ZliveStatus fx-ac space">
                <i />
                Live
              </span>
            </div>

            <strong>Checkout</strong>

            <div className="ZvisualAmount">₦250,000</div>

            <small>Today's sales</small>
          </div>

          {/* Scanner */}
          <div className="ZvisualCard ZvisualCard--scanner shadowA">
            <span className="ZvisualCardIcon fx-ac fx-jc">
              <QrCodeScannerIcon />
            </span>

            <div className="fx-cl">
              <strong>Camera Scanner</strong>
              <small>Ready to scan</small>
            </div>

            <CheckCircleIcon className="ZcheckIcon" />
          </div>

          {/* Transaction */}
          <div className="ZvisualCard ZvisualCard--transaction shadowA">
            <div className="fx-ac space">
              <span className="ZtransactionIcon fx-ac fx-jc">
                <ReceiptLongIcon />
              </span>

              <div className="fx-cl">
                <strong>Transaction completed</strong>
                <small>Just now</small>
              </div>
            </div>

            <span className="ZtransactionCheck">
              <CheckCircleIcon />
            </span>
          </div>
        </div>
      </div>

      {/* =========================================================
          Z PATTERN — 02
          ORDER FLOW
      ========================================================= */}

      <div className="ZpatternCont ZpatternCont--reverse">
        <div className="ZpatterAimg ZpatterAimg--workflow">
          <div className="ZpatternVisualGlow" />
          <img
            className="ZpatterAimg__main"
            src={UniPOSXImg}
            alt="Universe POS order workflow"
          />

          {/* Order card */}
          <div className="ZvisualCard ZvisualCard--order shadowA">
            <div className="fx-ac fx-jb">
              <div className="fx-ac space">
                <span className="ZminiIcon fx-ac fx-jc">
                  <StorefrontIcon />
                </span>

                <strong>New Order</strong>
              </div>

              <span className="ZorderBadge">#2048</span>
            </div>

            <div className="ZorderProgress">
              <span />
              <span />
              <span />
            </div>

            <div className="fx-ac fx-jb">
              <small>4 products</small>
              <strong>₦85,400</strong>
            </div>
          </div>

          {/* Inventory */}
          <div className="ZvisualCard ZvisualCard--inventory shadowA">
            <span className="ZvisualCardIcon fx-ac fx-jc">
              <Inventory2Icon />
            </span>

            <div className="fx-cl">
              <strong>Inventory Updated</strong>
              <small>Stock synchronized</small>
            </div>

            <SyncIcon className="ZsyncIcon" />
          </div>

          {/* Scan activity */}
          <div className="ZvisualCard ZvisualCard--scan shadowA">
            <span className="ZscanPulse" />

            <div className="fx-cl">
              <strong>Product scanned</strong>
              <small>Barcode detected successfully</small>
            </div>

            <QrCodeScannerIcon />
          </div>
        </div>

        <div className="ZpatternLeft fx-cl space2">
          <span className="ZpatternEyebrow fx-ac space">
            <QrCodeScannerIcon fontSize="small" />
            FASTER CHECKOUT
          </span>

          <h3 className="fs9 fw500 ">
            {" "}
            <span style={{ color: "#082e67" }}>Take Orders</span> and Keep
            Things <span style={{ color: "#082e67" }}>Moving</span>{" "}
          </h3>

          <p className="fs5 fw500 lh3 ZpatternDescription">
            Universe POS was built around the people who use it every day. From
            the cashier serving a customer to the owner watching the business
            from a distance, every part of the experience is designed to make
            selling feel natural and effortless.
          </p>

          <div className="ZpatternFeatureGrid g g2 space2">
            <div className="ZpatternFeature fx-cl space1">
              <div className="fx-ac space">
                <QrCodeScannerIcon />
                <h4>Integrated Cam-Scanner</h4>
              </div>

              <p>
                Your computer's camera can become part of the checkout
                experience, allowing products to be scanned directly from the
                POS.
              </p>
            </div>

            <div className="ZpatternFeature fx-cl space1">
              <div className="fx-ac space">
                <CloudDoneIcon />
                <h4>Connected Operations</h4>
              </div>

              <p>
                Keep your sales operation connected as transactions move beyond
                the physical counter.
              </p>
            </div>
          </div>

          <div className="ZpatternAction fx-ac space1">
            <button className="ZpatternButton fx-ac fx-jc space">
              See How It Works
              <ArrowForwardIcon />
            </button>

            <span className="ZpatternActionHint">Scan · Sell · Sync</span>
          </div>
        </div>
      </div>

      {/* =========================================================
          Z PATTERN — 03
          UNI-CLOUD
      ========================================================= */}

      <div className="ZpatternCont">
        <div className="ZpatternLeft fx-cl space2">
          <span className="ZpatternEyebrow fx-ac space">
            <CloudDoneIcon fontSize="small" />
            UNI-CLOUD
          </span>

          <h3 className="fs9 fw500 ">
            <span> Uni-Cloud </span>App, Your Business, Wherever{" "}
            <span>You Are</span>
          </h3>

          <p className="fs5 fw500 lh3 ZpatternDescription">
            Uni-Cloud gives business owners a direct view into the activity
            taking place across their operations, wherever they are. As the
            business moves, Uni-Cloud keeps you connected.
          </p>

          <p className="fs5 fw500 lh3 ZpatternDescription">
            A sale is completed. A sale is returned. Stock is transferred. A new
            product is added. A contact is created. Inventory changes. Instead
            of waiting until you return to the business, Uni-Cloud keeps you
            informed as the activity takes place.
          </p>

          <div className="ZcloudMetrics g g3 space1">
            <div className="ZcloudMetric fx-cl">
              <strong>24/7</strong>
              <span>Business visibility</span>
            </div>

            <div className="ZcloudMetric fx-cl">
              <strong>Live</strong>
              <span>Activity updates</span>
            </div>

            <div className="ZcloudMetric fx-cl">
              <strong>1</strong>
              <span>Connected operation</span>
            </div>
          </div>

          <div className="ZpatternAction fx-ac space1">
            <button className="ZpatternButton fx-ac fx-jc space">
              Discover Uni-Cloud
              <ArrowForwardIcon />
            </button>
          </div>
        </div>

        <div className="ZpatterAimg ZpatterAimg--cloud">
          <div className="ZpatternVisualGlow" />

          <img
            className="ZpatterAimg__main"
            src={UniCloudImg}
            alt="Uni-Cloud business management"
          />

          {/* Cloud status */}
          <div className="ZvisualCard ZvisualCard--cloudStatus shadowA">
            <div className="fx-ac space">
              <span className="ZcloudIcon fx-ac fx-jc">
                <CloudDoneIcon />
              </span>

              <div className="fx-cl">
                <strong>Uni-Cloud</strong>
                <small>Everything is connected</small>
              </div>
            </div>

            <div className="ZcloudOnline fx-ac space">
              <i />
              All systems operational
            </div>
          </div>

          {/* Activity feed */}
          <div className="ZvisualCard ZvisualCard--activity shadowA">
            <div className="fx-ac fx-jb">
              <strong>Live Activity</strong>
              <span>Now</span>
            </div>

            <div className="ZactivityItem fx-ac space">
              <span className="ZactivityIcon fx-ac fx-jc">
                <ReceiptLongIcon />
              </span>

              <div className="fx-cl">
                <strong>Sale completed</strong>
                <small>₦48,500 · POS 02</small>
              </div>
            </div>

            <div className="ZactivityItem fx-ac space">
              <span className="ZactivityIcon fx-ac fx-jc">
                <Inventory2Icon />
              </span>

              <div className="fx-cl">
                <strong>Stock updated</strong>
                <small>Warehouse A</small>
              </div>
            </div>

            <div className="ZactivityItem fx-ac space">
              <span className="ZactivityIcon fx-ac fx-jc">
                <SyncIcon />
              </span>

              <div className="fx-cl">
                <strong>Data synchronized</strong>
                <small>Just now</small>
              </div>
            </div>
          </div>

          {/* Growth */}
          <div className="ZvisualCard ZvisualCard--growth shadowA">
            <span className="ZgrowthIcon fx-ac fx-jc">
              <TrendingUpIcon />
            </span>

            <div className="fx-cl">
              <small>Today's performance</small>
              <strong>+18.4%</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
